import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/download.svg'
import _imports_1 from '../../assets/images/folder.svg'
import _imports_2 from '../../assets/images/required_file.svg'
import _imports_3 from '../../assets/images/woman.svg'
import _imports_4 from '../../assets/images/team.svg'
import _imports_5 from '../../assets/images/under_construction.svg'


const _hoisted_1 = { class: "content w-full rounded-t" }
const _hoisted_2 = { class: "flex flex-col items-center mt-6" }
const _hoisted_3 = { class: "font-bold text-4xl text-curaduriaDark decoration-curaduria" }
const _hoisted_4 = { class: "relative w-full py-18 mt-8 2xl:py-18 overflow-hidden" }
const _hoisted_5 = { class: "container w-full mx-auto" }
const _hoisted_6 = { class: "flex flex-wrap -m-6" }
const _hoisted_7 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_9 = { class: "relative px-4 -mt-16" }
const _hoisted_10 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_11 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_12 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_13 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate h-12" }
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://drive.google.com/file/d/15atUVl_mSzbqP1lqlbD10gXVSyeKx1hV/view",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_16 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_18 = { class: "relative px-4 -mt-16" }
const _hoisted_19 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_20 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_21 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_22 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate h-12" }
const _hoisted_23 = { class: "mt-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/resoluciones" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_25 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_27 = { class: "relative px-4 -mt-16" }
const _hoisted_28 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_29 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_30 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_31 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate h-12" }
const _hoisted_32 = { class: "mt-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/documentos" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_34 = { class: "mt-8" }
const _hoisted_35 = { class: "relative py-18 2xl:py-20 overflow-hidden" }
const _hoisted_36 = { class: "container w-full mx-auto" }
const _hoisted_37 = { class: "flex flex-wrap -m-6" }
const _hoisted_38 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_40 = { class: "relative px-4 -mt-16" }
const _hoisted_41 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_42 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_43 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_44 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate" }
const _hoisted_45 = { class: "mt-1" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/normatividad" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_47 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_49 = { class: "relative px-4 -mt-16" }
const _hoisted_50 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_51 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_52 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_53 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate" }
const _hoisted_54 = { class: "mt-1" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/nosotros" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)
const _hoisted_56 = { class: "relative w-full lg:w-1/3 p-6" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "h-18 bg-white w-full sm:h-12 md:h-72 md:w-196 object-contain object-center rounded-lg shadow-md"
}, null, -1)
const _hoisted_58 = { class: "relative px-4 -mt-16" }
const _hoisted_59 = { class: "bg-curaduria p-6 rounded-lg shadow-lg" }
const _hoisted_60 = { class: "flex items-baseline w-full justify-center" }
const _hoisted_61 = { class: "bg-white text-curaduria text-xs px-2 inline-block rounded-full uppercase font-semibold tracking-wide" }
const _hoisted_62 = { class: "mt-1 text-xl font-semibold uppercase leading-tight truncate h-12" }
const _hoisted_63 = { class: "mt-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 pl-32 md:pl-44" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/transparencia" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-10 w-10 hover:animate-bounce",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z",
        "clip-rule": "evenodd"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("content.titleSection")), 1),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("home.badgeDoc")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$t("content.title1")), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("content.des1")), 1),
                    _hoisted_15
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("home.badge")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_22, _toDisplayString(_ctx.$t("content.title2")), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("content.des2")), 1),
                    _hoisted_24
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("home.badge")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.$t("content.title3")), 1),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t("content.des3")), 1),
                    _hoisted_33
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("section", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", null, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("home.badge")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.$t("content.title4")), 1),
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("content.des4")), 1),
                    _hoisted_46
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", null, [
                _hoisted_48,
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("home.badge")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_53, _toDisplayString(_ctx.$t("content.title5")), 1),
                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("content.des5")), 1),
                    _hoisted_55
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", null, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("home.badge")), 1)
                    ]),
                    _createElementVNode("h4", _hoisted_62, _toDisplayString(_ctx.$t("content.title6")), 1),
                    _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("content.des6")), 1),
                    _hoisted_64
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}